import { useMutation, gql } from '@apollo/client';
import { IMainDirectoryListItem } from './useAllMainDirectoryListQuery';

export const favouriteMainDirectoryListItemMutation = gql`
    mutation FavouriteMainDirectoryListItem($params: DirectoryListMutateInput!) {
        updateMainDirectoryList(params: $params) {
            result {
                id
                dateCreated {
                    js
                }
                dateModified {
                    js
                }
                description
                caption
                favourite
                folder
                listType
                parentID
                recordType
                securityUserID
                tableName
            }
            hasErrors
        }
    }
`;

export interface IMutateMainDirectoryListItemVars {
    params: {
        listID: number;
        listType: starrez.DirectoryListTypeEnum;
        favourite: boolean;
    };
}

export interface IMutateMainDirectoryListItemData {
    updateMainDirectoryList: {
        result: IMainDirectoryListItem;
        hasErrors: boolean;
        __typename?: string;
    };
}

export const useFavouriteMainDirectoryListItem = () =>
    useMutation<IMutateMainDirectoryListItemData, IMutateMainDirectoryListItemVars>(favouriteMainDirectoryListItemMutation);
